import { InstallmentItem, GuarantorItem, FeeItem, FeesData } from '../types/operations';

export const isValidDate = (dateString: string): boolean => {
    if (!dateString || dateString.length !== 10) return false;
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) return false;
    const [day, month, year] = dateString.split('/').map(Number);
    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) return false;
    const date = new Date(year, month - 1, day);
    return date.getDate() === day && date.getMonth() === month - 1 && date.getFullYear() === year;
};

export const formatDateWithoutTimezone = (dateStr: string): string => {
    if (!dateStr) return '';
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) return dateStr;
    if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
        const [year, month, day] = dateStr.split('T')[0].split('-');
        return `${day}/${month}/${year}`;
    }
    return dateStr;
};

export const reprocessInstallmentNumbers = (installments: InstallmentItem[]): InstallmentItem[] => {
    const sorted = [...installments].sort((a, b) => {
        const dateA = new Date(a.dueDate.split('/').reverse().join('-'));
        const dateB = new Date(b.dueDate.split('/').reverse().join('-'));
        return dateA.getTime() - dateB.getTime();
    });
    return sorted.map((item, index) => ({ ...item, number: index + 1 }));
};

export const loadGuarantorsFromParticipants = (participants?: any[]): { items: GuarantorItem[]; quantity: number } => {
    if (!participants) return { items: [], quantity: 0 };

    const guarantorParticipants = participants.filter(p => {
        const participantType = p.participant_type_name || p.participant_type;
        return participantType === 'GUARANTOR' || participantType === 'GUARANTOR-RETAIL';
    });

    const items = guarantorParticipants.map((p: any) => ({
        id: p.id ? String(p.id) : undefined,
        uuid: p.person_id || '',
        name: p.name || '',
        document: p.document || '',
        entity_type: p.entity_type || 'FIDEJUSSÓRIA',
        participant_type_name: p.participant_type_name || p.participant_type || '',
    }));

    return { items, quantity: items.length };
};

export const loadFees = (fees: any): FeesData => {
    if (!fees) return { items: [], quantity: 0 };

    const mapFee = (fee: any): FeeItem => ({
        name: fee.fee_name || fee.name || '',
        rate: Number.parseFloat(fee.rate ?? fee.fee_value ?? '0') || 0,
        amount: Number.parseFloat(fee.amount ?? fee.fee_value ?? '0') || 0,
        form: fee.form || '',
        interest_period: fee.interest_period || '',
    });

    if (Array.isArray(fees)) {
        return { items: fees.map(mapFee), quantity: fees.length };
    }

    const items = (fees.items || []).map(mapFee);
    return { items, quantity: fees.quantity || items.length };
};
